<template>
  <div class="forgot-page">
    <div class="content">
      <div class="content__header">
        <div class="content__header--title">
          <h2 class="small-title">Reset Password</h2>
          <p>Please enter the email address associated with your active account, and we’ll email you a link to reset your password.</p>
        </div>
      </div>
      <div class="content__input">
        <adx-form
          @complete="onComplete($event)"
          :schema="schema"
          :model.sync="model"
          :error.sync="error"
          :onSubmit="onSubmit"
          :wrapper="wrapper" />
      </div>
      <div class="content__fulldivider">

      </div>
      <div class="content__footer">
        <div class="signup subhead">
          <span class="subhead" @click="goToSignin">Back to sign in</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormAbstraction from '@/components/Form'

import api from '@/api'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-forgot-page',
  components: {
    'adx-form': FormAbstraction
  },
  props: {

  },
  data() {
    return {
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: ``,
        password: ``,
        remember: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Send Reset Link`,
            uri: apiV2.forgot,
            params: this.model,
            method: `post`, // HTTP Method
            class: `btn-block primary reset`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email',
              model: 'email',
              method: 'onChange',
              validation: ['NotEmpty', 'Email']
            }
          ]
        },
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    onComplete({ args }) {
      const { data } = args
      const { message, redirect_to } = data
      this.$router.replace({ path: redirect_to })
    },
    goToSignin() {
      this.$router.push({name: 'signin'})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>